import React from "react";
import { Box, CircularProgress } from "@material-ui/core";

const LoaderWrapper = ({ children, loading, notTable = false }) => {
  return (
    <Box position="relative" minHeight="100px">
      {children}
      {loading && (
        <Box
          position="absolute"
          top="0"
          height="100%"
          width={notTable ? "calc(100% + 80px)" : "100%"}
          zIndex="1111"
          padding="30px"
          marginLeft={notTable ? "-40px" : ""}
          style={{
            backgroundColor: "#eeeeee69",
          }}
        >
          <CircularProgress size={40} thickness={4} />
        </Box>
      )}
    </Box>
  );
};

export default LoaderWrapper;
